export default __webpack_public_path__ + "static/media/1920 knife block A top.73705664.png";